import MissionButton from '../MissionButton'

import { Container, IconImage, InfoWrapper, InlineEnergyIcon, SubText, TextWrapper, Title } from './styles'

interface MissionItemProps {
  iconSrc: string
  title: string
  description: string
  secondDescription?: string
  isCompleted: boolean
  onAction: () => void
}

export default function MissionItem({
  iconSrc,
  title,
  description,
  secondDescription,
  isCompleted,
  onAction,
}: MissionItemProps) {
  return (
    <Container>
      <InfoWrapper>
        <IconImage src={iconSrc} alt='' />
        <TextWrapper>
          <Title isCompleted={isCompleted}>{title}</Title>
          <SubText isCompleted={isCompleted}>
            <span>{description}</span>
            <InlineEnergyIcon isCompleted={isCompleted} />
            {secondDescription && (
              <>
                <span>{secondDescription}</span>
                <InlineEnergyIcon isCompleted={isCompleted} />
              </>
            )}
          </SubText>
        </TextWrapper>
      </InfoWrapper>
      <MissionButton onClick={onAction} isCompleted={isCompleted} />
    </Container>
  )
}
